import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { logo192 } from "../../../assets/logo192";

const TopHeaderBar = ({ drawerWidth, username, handleLogout }) => {
  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + drawerWidth }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <img src={logo192} alt="Logo" style={{ height: "64px" }} />
          <Typography sx={{ paddingLeft: "16px" }} variant="h6" component="div">
            米狗订单系统
          </Typography>
        </Box>
        <Typography sx={{ paddingRight: "16px" }} variant="h6" component="div">
          {username || "未登录"}
        </Typography>
        {username && username !== "未登录" && (
          <Button color="inherit" onClick={handleLogout}>
            退出登录
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopHeaderBar;
